const {
    CLEAR_PAGE,
    COMPLETE_PAGE_SCORING,
    INVALIDATE_PAGE,
    PAGE_INFO_SET,
    RECEIVE_PAGE,
    REFRESH_BUCKETS,
    REPLACE_HERO,
    REQUEST_PAGE
} = require('../actions');

function getHero(state, { buckets = [], heroContent }) {
    // Use the "concrete" hero if it already exists (this is if the id was passed in directly to the page)
    if (state.hero && state.hero.concrete === true) {
        return state.hero;
    }

    // If the hero content was retrieved as part of the page load action, use it.
    if (heroContent) {
        return heroContent;
    }

    // If there's no buckets, there's no content to make the hero.
    if (buckets.length === 0) {
        return null;
    }

    // Find the bucket index that contains the top scored item.
    const topBucketIndex = buckets
            .filter((bucket) => bucket.contents.length > 0)
            .map((bucket, index) => ({ score: bucket.contents[0].score || 0, index }))
            .sort((itemA, itemB) => itemB.score - itemA.score)
            .map((object) => object.index)
            .shift();

    // If no top bucket index was found, then there's no hero.
    // This could happen if the buckets array exists, but the contents were all empty.
    if (topBucketIndex === undefined || !buckets[topBucketIndex]) {
        return null;
    }

    // Build and return the hero bucket.
    return buckets[topBucketIndex].contents[0];
}

function reinsertBuckets(state, { buckets = [] }) {
    return buckets.reduce((prev, bucket) => {
        const index = state.buckets.map((buck) => buck.id).indexOf(bucket.id);
        return [
            ...prev.slice(0, index),
            bucket,
            ...prev.slice(index + 1)
        ];
    }, state.buckets);
}

function replaceBuckets(state, replacementBuckets) {
    return state.buckets.map((bucket) => {
        let newBucket = bucket;
        replacementBuckets.forEach((replacementBucket) => {
            if (bucket.id === replacementBucket.id) {
                newBucket = replacementBucket;
            }
        });
        // the __replaced property is used when we first get to the player page from a bucket
        // delete it when we replace buckets so that TabContainer doesn't use it to select a tab
        // #TODO: we can probably accomplish the initial replacement without this flag
        delete newBucket.__replaced;
        return newBucket;
    });
}

function completeScoring(state, action) {
    const buckets = reinsertBuckets(state, action);
    const hero = getHero(state, { buckets, heroContent: action.heroContent });
    return { ...state, buckets, hero, scored: true };
}

module.exports = function page(state = {}, action) {
    switch (action.type) {
        case CLEAR_PAGE:
            return {};

        case INVALIDATE_PAGE:
            return { ...state, didInvalidate: true };

        case REFRESH_BUCKETS:
            return {
                ...state,
                buckets: replaceBuckets(state, action.buckets)
            };

        case REQUEST_PAGE:
            return {
                ...state,
                id: action.id,
                isFetching: true,
                didInvalidate: false,
                requestedTime: action.requestedTime,
                scored: false
            };

        case RECEIVE_PAGE:
            return {
                ...state,
                id: action.id,
                name: action.name,
                edition: action.edition,
                lang: action.lang,
                isFetching: false,
                didInvalidate: false,
                buckets: action.buckets,
                receivedTime: action.receivedTime,
                tracking: action.tracking,
                hero: getHero(state, action),
                error: action.error
            };

        case REPLACE_HERO:
            return {
                ...state,
                hero: action.content || state.hero
            };

        case COMPLETE_PAGE_SCORING:
            return completeScoring(state, action);

        case PAGE_INFO_SET:
            return {
                ...state,
                name: action.name,
                id: action.id
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./app/page/reducers/index.js